export const FAILED_REQUEST = "AUTH_FAILED_REQUEST";
export const LOADING_REQUEST = "AUTH_LOADING_REQUEST";

export const LOGIN_SUCCESS = "AUTH_LOGIN_SUCCESS";

export const LOGOUT_SUCCESS = "AUTH_LOGOUT_SUCCESS";

export const SHOP_PROFILE = "ADD_SHOP_PROFILE"

export const SET_NOTIFICATIONS = "SET_NOTIFICATIONS"
export const ADD_NOTIFICATIONS = "ADD_NOTIFICATIONS"


export const WAITING_TRUE = "WAITING_SHOP_ASSIGNMENT_TRUE";

export const WAITING_FALSE = "WAITING_SHOP_ASSIGNMENT_FALSE";
